import { FieldPracticeResponse } from "models";

/**
 * Get crop name from cropId
 * @param cropId - The crop ID to look up
 * @param fieldPractices - The field practices data containing crops
 * @returns The crop name or null if not found
 */
export const getCropName = (cropId: string | undefined, fieldPractices?: FieldPracticeResponse): string | null => {
  if (!cropId) return null;
  const crop = fieldPractices?.crops?.find((c) => c.id === cropId);
  return crop?.cropName ?? null;
};
